import geolocationService from "@/services/geolocation";

// 引数:{lat: "", lng: ""}
// 第1引数:左下緯度経度 第2引数:右上緯度経度
export const isInsideArea = async (PolygonLu, PolygonRd) => {
  const position = await geolocationService
    .getCurrentPosition()
    .catch((err) => {
      throw err;
    });

  // 緯度経度だけ取得
  const currentLat = position.coords.latitude;
  const currentLng = position.coords.longitude;

  // 現在地と引数で内外判定
  // true: 範囲内
  // false: 範囲外
  return !(
    currentLat <= PolygonLu.lat ||
    PolygonRd.lat <= currentLat ||
    currentLng <= PolygonLu.lng ||
    PolygonRd.lng <= currentLng
  );
};
